import join from 'url-join';

import { PageURL } from '@app/core/widgets/pages';

export const DISPLAY_OPTIONS = join(PageURL.BANK_ACCOUNT, '/display-options');
export const GROUPS_MANAGEMENT = join(PageURL.BANK_ACCOUNT, '/groups-management');
export const LINK_INTERNAL_ACCOUNT = join(PageURL.BANK_ACCOUNT, '/link-internal-account');
export const OVERDRAFT_PROTECTION = join(PageURL.BANK_ACCOUNT, '/overdraft-protection');
export const YEAR_END_INFORMATION = join(PageURL.BANK_ACCOUNT, '/year-end-info');

export const DOWNLOAD_EXPORT_FILE_EVENT = 'ast.downloadTransactionsExportFile';
export const DOWNLOAD_IMAGE_FILE_EVENT = 'ast.downloadTransactionImageFile';
export const PRINT_TRANSACTIONS_EXPORT_EVENT = 'ast.printTransactionsExport';
export const PRINT_IMAGE_EVENT = 'ast.printTransactionImage';

export const INVESTMENT_SSO_ID = 'Talos';

export const WEEK_LENGTH = 7;

export enum AccountsSummaryGraphViewType {
  WEEK = 'week',
  MONTH = 'month',
}
export const NICKNAME_MAX_LENGTH = 30;
export const ACCOUNT_NUMBER_MAX_LENGTH = 20;
